import React from 'react';
import ProgramInfoModal from './ProgramInfoModal';
import ThemeSettingsModal from './ThemeSettingsModal';
import MerchantsModal from './MerchantsModal';
import EngagementModal from './EngagementModal';
import DigitalMediaModal from "./DigitalMediaModal";
import EntrataSettingsModal from "./EntrataSettingsModal";
//import EmailTemplateModal from '../EmailTemplate/IndexDataModal'
import ActivateLiveModeProgramModal from "./ActivateLiveModeProgramModal";
//import ReportsModal from "./ReportsModal";
//import CsvImporttypesModal from "./CsvImporttypesModal";
import AddProgramModal from './AddProgramModal';
//import UnitNumbersDataModal from './UnitNumbers/UnitNumberDataModal'
//import PositionLevelsModal from './positions/PositionLevelsModal';

const MainModalWrapper = ({ name, isOpen, setOpen, toggle }) => {
  const props = {
    isOpen, setOpen, toggle
  }
  return (
    <>
      {
        name === 'general' && <ProgramInfoModal {...props} />
      }
      {
        name === 'merchants' && <MerchantsModal {...props} />
      }
      {
        name === 'engagement' && <EngagementModal {...props} />
      }
      {
        name === 'addprogram' && <AddProgramModal {...props} />
      }
      {
        name === 'users' && <AddProgramModal {...props} />
      }
      {
        name === 'themesettings' && <ThemeSettingsModal {...props} />
      }
      {
        name === 'digitalmedia' && <DigitalMediaModal {...props} />
      }
      {
        name === 'activateLiveMode' && <ActivateLiveModeProgramModal {...props} />
      }
      {
        name === 'entratasettings' && <EntrataSettingsModal {...props} />
      }

    </>
  )
}

export default MainModalWrapper;
